export default __webpack_public_path__ + "static/media/goldman.661eadcb.svg";